import numeral from 'numeral'

numeral.register('locale', 'GBP', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: '£'
  }
})
numeral.register('locale', 'EUR', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: '€'
  }
})
numeral.register('locale', 'USD', {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  currency: {
    symbol: '$'
  }
})
numeral.locale('GBP')

// Was `Vue.prototype.$numeral = numeral` as an import side effect — see moment.js.
export default {
  install(app) {
    app.config.globalProperties.$numeral = numeral
  }
}
